import { motion } from "framer-motion";
import { ArrowDown } from "@phosphor-icons/react";

const HERO_BG = "https://customer-assets.emergentagent.com/job_site-yapalim-1/artifacts/v411di67_Gemini_Generated_Image_8m85r18m85r18m85.jpg";

const Hero = () => {
  return (
    <section
      id="hero"
      data-testid="hero-section"
      className="relative min-h-screen flex items-end pb-20 sm:pb-32"
    >
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src={HERO_BG}
          alt="Mardin manzarası"
          className="w-full h-full object-cover"
        />
        <div className="hero-overlay absolute inset-0" />
      </div>

      {/* Content */}
      <div className="container-main relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1], delay: 0.2 }}
          className="max-w-3xl"
        >
          <motion.span
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.5, duration: 0.6 }}
            className="inline-block mb-6 px-4 py-1.5 rounded-full bg-white/10 backdrop-blur-md border border-white/20 text-white/90 text-xs sm:text-sm font-['Outfit'] tracking-[0.2em] uppercase"
          >
            Mardin'in Prestijli Konaklama Adresi
          </motion.span>

          <h1 className="font-['Playfair_Display'] text-5xl sm:text-6xl lg:text-7xl text-white font-bold tracking-tighter leading-[0.95] mb-6">
            DVT{" "}
            <span className="text-[#C46235]">Rezidans</span>
          </h1>

          <p className="font-['Outfit'] text-lg sm:text-xl text-white/80 leading-relaxed max-w-xl mb-10">
            Konforunuz için her detayın özenle tasarlandığı 1+1 ve 2+0 lüks dairelerimizle DVT Rezidans hizmetinizde.
          </p>

          <div className="flex flex-wrap gap-4">
            <button
              data-testid="hero-cta-button"
              onClick={() => document.querySelector("#iletisim")?.scrollIntoView({ behavior: "smooth" })}
              className="px-8 py-4 bg-[#C46235] text-white font-['Outfit'] font-semibold text-sm sm:text-base rounded-full transition-all duration-300 hover:bg-[#A6522B] hover:shadow-xl hover:shadow-[#C46235]/25 hover:-translate-y-0.5"
            >
              Hemen Bilgi Alın
            </button>
            <button
              data-testid="hero-explore-button"
              onClick={() => document.querySelector("#hakkimizda")?.scrollIntoView({ behavior: "smooth" })}
              className="px-8 py-4 bg-white/10 backdrop-blur-md border border-white/30 text-white font-['Outfit'] font-medium text-sm sm:text-base rounded-full transition-all duration-300 hover:bg-white/20 hover:-translate-y-0.5"
            >
              Keşfedin
            </button>
          </div>
        </motion.div>

        {/* Scroll indicator */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1.2 }}
          className="absolute bottom-8 right-8 hidden sm:flex flex-col items-center gap-2"
        >
          <span className="font-['Outfit'] text-xs text-white/50 tracking-widest uppercase">Aşağı</span>
          <motion.div
            animate={{ y: [0, 8, 0] }}
            transition={{ repeat: Infinity, duration: 1.8, ease: "easeInOut" }}
          >
            <ArrowDown size={20} className="text-white/50" />
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default Hero;
